export default __webpack_public_path__ + "static/media/chargebee-logo.0e3502c7.svg";